module.exports = {
	"nm": "image upload",
	"h": 1200,
	"w": 1200,
	"meta": {
		"g": "@lottiefiles/toolkit-js 0.33.2"
	},
	"layers": [
		{
			"ty": 4,
			"nm": "tick",
			"sr": 1,
			"st": 0,
			"op": 150,
			"ip": 150,
			"hasMask": false,
			"ao": 0,
			"ks": {
				"a": {
					"a": 0,
					"k": [
						256,
						256,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				},
				"sk": {
					"a": 0,
					"k": 0
				},
				"p": {
					"a": 0,
					"k": [
						600,
						600,
						0
					],
					"ix": 2
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"sa": {
					"a": 0,
					"k": 0
				},
				"o": {
					"a": 1,
					"k": [
						{
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"s": [
								0
							],
							"t": 80
						},
						{
							"s": [
								100
							],
							"t": 90
						}
					],
					"ix": 11
				}
			},
			"ef": [],
			"shapes": [
				{
					"ty": "gr",
					"nm": "tick",
					"ix": 1,
					"cix": 2,
					"it": [
						{
							"ty": "sh",
							"nm": "Path 1",
							"ix": 1,
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": false,
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											118.858,
											-107.5
										],
										[
											-50.33,
											107.5
										],
										[
											-118.857,
											20.442
										]
									]
								},
								"ix": 2
							}
						},
						{
							"ty": "st",
							"nm": "Stroke 1",
							"lc": 2,
							"lj": 2,
							"ml": 1,
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 40,
								"ix": 5
							},
							"c": {
								"a": 0,
								"k": [
									0.161,
									0.835,
									0.604
								],
								"ix": 3
							}
						},
						{
							"ty": "tr",
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"p": {
								"a": 0,
								"k": [
									258.857,
									267.611
								],
								"ix": 2
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							}
						}
					]
				}
			],
			"ind": 1
		},
		{
			"ty": 4,
			"nm": "Shape Layer 1",
			"sr": 1,
			"st": 0,
			"op": 150,
			"ip": 0,
			"hasMask": false,
			"ao": 0,
			"ks": {
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 1,
					"k": [
						{
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"s": [
								0,
								100,
								100
							],
							"t": 0
						},
						{
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"s": [
								120,
								100,
								100
							],
							"t": 10
						},
						{
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"s": [
								120,
								100,
								100
							],
							"t": 65
						},
						{
							"s": [
								0,
								100,
								100
							],
							"t": 80
						}
					],
					"ix": 6
				},
				"sk": {
					"a": 0,
					"k": 0
				},
				"p": {
					"a": 1,
					"k": [
						{
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"s": [
								600,
								808,
								0
							],
							"t": 10,
							"ti": [
								0,
								66.5,
								0
							],
							"to": [
								0,
								-66.5,
								0
							]
						},
						{
							"s": [
								600,
								409,
								0
							],
							"t": 60
						}
					],
					"ix": 2
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"sa": {
					"a": 0,
					"k": 0
				},
				"o": {
					"a": 1,
					"k": [
						{
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"s": [
								100
							],
							"t": 65
						},
						{
							"s": [
								0
							],
							"t": 80
						}
					],
					"ix": 11
				}
			},
			"ef": [],
			"shapes": [
				{
					"ty": "gr",
					"nm": "Rectangle 1",
					"ix": 1,
					"cix": 2,
					"it": [
						{
							"ty": "rc",
							"nm": "Rectangle Path 1",
							"d": 1,
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 20,
								"ix": 4
							},
							"s": {
								"a": 0,
								"k": [
									562.727,
									33.344
								],
								"ix": 2
							}
						},
						{
							"ty": "fl",
							"nm": "Fill 1",
							"c": {
								"a": 0,
								"k": [
									0.471,
									0.878,
									0.561
								],
								"ix": 4,
								"x": "var $bm_rt;\n$bm_rt = thisComp.layer('image ready').content('image frame').content('sun').content('Fill 1').color;"
							},
							"r": 1,
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							}
						},
						{
							"ty": "tr",
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"p": {
								"a": 0,
								"k": [
									-0.637,
									-9.328
								],
								"ix": 2
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							}
						}
					]
				}
			],
			"ind": 2
		},
		{
			"ty": 4,
			"nm": "image ready",
			"sr": 1,
			"st": 0,
			"op": 150,
			"ip": 0,
			"hasMask": true,
			"ao": 0,
			"ks": {
				"a": {
					"a": 0,
					"k": [
						256,
						256,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				},
				"sk": {
					"a": 0,
					"k": 0
				},
				"p": {
					"a": 0,
					"k": [
						600,
						600,
						0
					],
					"ix": 2
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"sa": {
					"a": 0,
					"k": 0
				},
				"o": {
					"a": 1,
					"k": [
						{
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"s": [
								100
							],
							"t": 80
						},
						{
							"s": [
								0
							],
							"t": 90
						}
					],
					"ix": 11
				}
			},
			"ef": [],
			"masksProperties": [
				{
					"nm": "Mask 1",
					"inv": false,
					"mode": "a",
					"x": {
						"a": 0,
						"k": 0,
						"ix": 4
					},
					"o": {
						"a": 0,
						"k": 100,
						"ix": 3
					},
					"pt": {
						"a": 1,
						"k": [
							{
								"o": {
									"x": 0.167,
									"y": 0.167
								},
								"i": {
									"x": 0.833,
									"y": 0.833
								},
								"s": [
									{
										"c": true,
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												0,
												476
											],
											[
												0,
												476.001
											],
											[
												512,
												476.001
											],
											[
												512,
												476
											]
										]
									}
								],
								"t": 10
							},
							{
								"s": [
									{
										"c": true,
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												0,
												36
											],
											[
												0,
												476.001
											],
											[
												512,
												476.001
											],
											[
												512,
												36
											]
										]
									}
								],
								"t": 60
							}
						],
						"ix": 1
					}
				}
			],
			"shapes": [
				{
					"ty": "gr",
					"nm": "image frame",
					"ix": 1,
					"cix": 2,
					"it": [
						{
							"ty": "gr",
							"nm": "sun",
							"ix": 1,
							"cix": 2,
							"it": [
								{
									"ty": "sh",
									"nm": "Path 1",
									"ix": 1,
									"d": 1,
									"ks": {
										"a": 0,
										"k": {
											"c": true,
											"i": [
												[
													-11.028,
													0
												],
												[
													0,
													-11.028
												],
												[
													11.028,
													0
												],
												[
													0,
													11.028
												]
											],
											"o": [
												[
													11.028,
													0
												],
												[
													0,
													11.028
												],
												[
													-11.028,
													0
												],
												[
													0,
													-11.028
												]
											],
											"v": [
												[
													0,
													-20
												],
												[
													20,
													0
												],
												[
													0,
													20
												],
												[
													-20,
													0
												]
											]
										},
										"ix": 2
									}
								},
								{
									"ty": "sh",
									"nm": "Path 2",
									"ix": 2,
									"d": 1,
									"ks": {
										"a": 0,
										"k": {
											"c": true,
											"i": [
												[
													-33.084,
													0
												],
												[
													0,
													33.084
												],
												[
													33.084,
													0
												],
												[
													0,
													-33.084
												]
											],
											"o": [
												[
													33.084,
													0
												],
												[
													0,
													-33.084
												],
												[
													-33.084,
													0
												],
												[
													0,
													33.084
												]
											],
											"v": [
												[
													0,
													60
												],
												[
													60,
													0
												],
												[
													0,
													-60
												],
												[
													-60,
													0
												]
											]
										},
										"ix": 2
									}
								},
								{
									"ty": "mm",
									"nm": "Merge Paths 1",
									"mm": 1
								},
								{
									"ty": "fl",
									"nm": "Fill 1",
									"c": {
										"a": 0,
										"k": [
											0.161,
											0.835,
											0.604
										],
										"ix": 4
									},
									"r": 1,
									"o": {
										"a": 0,
										"k": 100,
										"ix": 5
									}
								},
								{
									"ty": "tr",
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"p": {
										"a": 0,
										"k": [
											140,
											168
										],
										"ix": 2
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									}
								}
							]
						},
						{
							"ty": "gr",
							"nm": "image",
							"ix": 2,
							"cix": 2,
							"it": [
								{
									"ty": "sh",
									"nm": "Path 1",
									"ix": 1,
									"d": 1,
									"ks": {
										"a": 0,
										"k": {
											"c": true,
											"i": [
												[
													0,
													0
												],
												[
													0,
													22.056
												],
												[
													0,
													0
												],
												[
													-22.056,
													0
												],
												[
													0,
													0
												],
												[
													0,
													-22.056
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													6.037,
													-0.091
												],
												[
													3.723,
													-4.736
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													6.202,
													0
												],
												[
													0,
													0
												],
												[
													3.784,
													-4.919
												],
												[
													0,
													0
												],
												[
													-8.755,
													-6.735
												],
												[
													-6.734,
													8.755
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													-22.056,
													0
												],
												[
													0,
													0
												],
												[
													0,
													-22.056
												],
												[
													0,
													0
												],
												[
													22.056,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-3.87,
													-4.618
												],
												[
													-6.024,
													0.094
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-3.786,
													-4.913
												],
												[
													0,
													0
												],
												[
													-6.206,
													0.003
												],
												[
													0,
													0
												],
												[
													-6.734,
													8.755
												],
												[
													8.757,
													6.735
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-176,
													180
												],
												[
													-216,
													140
												],
												[
													-216,
													-140
												],
												[
													-176,
													-180
												],
												[
													176,
													-180
												],
												[
													216,
													-140
												],
												[
													216,
													-14.993
												],
												[
													137.327,
													-108.848
												],
												[
													121.687,
													-115.998
												],
												[
													106.278,
													-108.362
												],
												[
													-47.84,
													87.664
												],
												[
													-100.16,
													19.789
												],
												[
													-116,
													11.999
												],
												[
													-116.01,
													11.999
												],
												[
													-131.853,
													19.805
												],
												[
													-175.868,
													77.023
												],
												[
													-172.21,
													105.07
												],
												[
													-144.163,
													101.413
												],
												[
													-115.984,
													64.78
												],
												[
													-27.168,
													180
												]
											]
										},
										"ix": 2
									}
								},
								{
									"ty": "sh",
									"nm": "Path 2",
									"ix": 2,
									"d": 1,
									"ks": {
										"a": 0,
										"k": {
											"c": true,
											"i": [
												[
													11.046,
													0
												],
												[
													0,
													-11.046
												],
												[
													22.056,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-0.205,
													-0.226
												],
												[
													0,
													0
												],
												[
													-0.025,
													-0.027
												],
												[
													-2.315,
													-1.079
												],
												[
													-2.776,
													-0.092
												],
												[
													-0.051,
													-0.001
												],
												[
													-0.008,
													-0.001
												],
												[
													-1.413,
													0.27
												],
												[
													0,
													0
												],
												[
													-0.064,
													0.013
												],
												[
													-0.026,
													0.005
												],
												[
													-0.054,
													0.012
												],
												[
													-0.03,
													0.007
												],
												[
													-0.049,
													0.011
												],
												[
													-0.034,
													0.009
												],
												[
													-0.043,
													0.01
												],
												[
													-0.038,
													0.009
												],
												[
													-0.041,
													0.01
												],
												[
													-0.038,
													0.01
												],
												[
													-0.042,
													0.011
												],
												[
													-0.038,
													0.01
												],
												[
													0,
													0
												],
												[
													-0.04,
													0.011
												],
												[
													-0.039,
													0.011
												],
												[
													-0.033,
													0.01
												],
												[
													-0.048,
													0.015
												],
												[
													-0.026,
													0.008
												],
												[
													-0.05,
													0.016
												],
												[
													-0.03,
													0.01
												],
												[
													-0.049,
													0.016
												],
												[
													-0.023,
													0.007
												],
												[
													-0.055,
													0.018
												],
												[
													-0.021,
													0.008
												],
												[
													-0.056,
													0.021
												],
												[
													-0.018,
													0.007
												],
												[
													-0.061,
													0.023
												],
												[
													0,
													0
												],
												[
													-0.068,
													0.027
												],
												[
													-0.004,
													0.002
												],
												[
													-0.073,
													0.031
												],
												[
													-0.844,
													0.499
												],
												[
													-0.012,
													0.007
												],
												[
													-0.057,
													0.035
												],
												[
													-0.932,
													0.842
												],
												[
													-0.017,
													0.015
												],
												[
													-0.015,
													0.013
												],
												[
													-1.085,
													2.33
												],
												[
													-0.088,
													2.788
												],
												[
													-0.001,
													0.036
												],
												[
													0,
													0.022
												],
												[
													-0.001,
													0.068
												],
												[
													0,
													0
												],
												[
													0,
													0.106
												],
												[
													0,
													0
												],
												[
													44.112,
													0
												],
												[
													0,
													0
												],
												[
													0,
													-44.113
												],
												[
													0,
													0
												],
												[
													-44.112,
													0
												],
												[
													0,
													0
												],
												[
													-0.047,
													0
												],
												[
													-0.063,
													0.001
												],
												[
													0,
													0
												],
												[
													0,
													44.112
												]
											],
											"o": [
												[
													-11.046,
													0
												],
												[
													0,
													22.056
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0.195,
													0.236
												],
												[
													0,
													0
												],
												[
													0.024,
													0.027
												],
												[
													1.821,
													1.989
												],
												[
													2.378,
													1.112
												],
												[
													0.051,
													0.002
												],
												[
													0.009,
													0
												],
												[
													1.429,
													0.036
												],
												[
													0,
													0
												],
												[
													0.063,
													-0.012
												],
												[
													0.024,
													-0.005
												],
												[
													0.054,
													-0.011
												],
												[
													0.03,
													-0.007
												],
												[
													0.05,
													-0.011
												],
												[
													0.035,
													-0.008
												],
												[
													0.044,
													-0.01
												],
												[
													0.038,
													-0.009
												],
												[
													0.041,
													-0.01
												],
												[
													0.038,
													-0.01
												],
												[
													0.042,
													-0.011
												],
												[
													0.038,
													-0.01
												],
												[
													0,
													0
												],
												[
													0.041,
													-0.012
												],
												[
													0.04,
													-0.011
												],
												[
													0.032,
													-0.009
												],
												[
													0.049,
													-0.015
												],
												[
													0.027,
													-0.008
												],
												[
													0.05,
													-0.015
												],
												[
													0.03,
													-0.01
												],
												[
													0.049,
													-0.016
												],
												[
													0.023,
													-0.008
												],
												[
													0.055,
													-0.019
												],
												[
													0.021,
													-0.007
												],
												[
													0.057,
													-0.019
												],
												[
													0.018,
													-0.007
												],
												[
													0.062,
													-0.023
												],
												[
													0,
													0
												],
												[
													0.068,
													-0.026
												],
												[
													0.004,
													-0.001
												],
												[
													0.073,
													-0.029
												],
												[
													0.889,
													-0.362
												],
												[
													0.012,
													-0.007
												],
												[
													0.057,
													-0.034
												],
												[
													1.078,
													-0.654
												],
												[
													0.017,
													-0.014
												],
												[
													0.015,
													-0.014
												],
												[
													2.005,
													-1.829
												],
												[
													1.115,
													-2.387
												],
												[
													0.001,
													-0.037
												],
												[
													0,
													-0.023
												],
												[
													0.001,
													-0.068
												],
												[
													0,
													0
												],
												[
													0.001,
													-0.105
												],
												[
													0,
													0
												],
												[
													0,
													-44.112
												],
												[
													0,
													0
												],
												[
													-44.112,
													0
												],
												[
													0,
													0
												],
												[
													0,
													44.112
												],
												[
													0,
													0
												],
												[
													0.047,
													0
												],
												[
													0.063,
													0
												],
												[
													0,
													0
												],
												[
													44.112,
													0
												],
												[
													0,
													-11.047
												]
											],
											"v": [
												[
													236,
													120
												],
												[
													216,
													140
												],
												[
													176,
													180
												],
												[
													23.335,
													180
												],
												[
													-22.65,
													120.344
												],
												[
													122.497,
													-64.274
												],
												[
													220.563,
													52.717
												],
												[
													221.163,
													53.411
												],
												[
													221.184,
													53.435
												],
												[
													221.258,
													53.516
												],
												[
													227.534,
													58.125
												],
												[
													235.322,
													59.987
												],
												[
													235.475,
													59.992
												],
												[
													235.501,
													59.992
												],
												[
													239.777,
													59.643
												],
												[
													239.83,
													59.633
												],
												[
													240.018,
													59.596
												],
												[
													240.094,
													59.58
												],
												[
													240.256,
													59.546
												],
												[
													240.346,
													59.526
												],
												[
													240.493,
													59.492
												],
												[
													240.597,
													59.468
												],
												[
													240.729,
													59.437
												],
												[
													240.842,
													59.409
												],
												[
													240.966,
													59.378
												],
												[
													241.079,
													59.348
												],
												[
													241.204,
													59.315
												],
												[
													241.318,
													59.284
												],
												[
													241.436,
													59.252
												],
												[
													241.558,
													59.217
												],
												[
													241.676,
													59.182
												],
												[
													241.773,
													59.154
												],
												[
													241.92,
													59.109
												],
												[
													242,
													59.083
												],
												[
													242.149,
													59.036
												],
												[
													242.239,
													59.007
												],
												[
													242.387,
													58.958
												],
												[
													242.456,
													58.935
												],
												[
													242.622,
													58.878
												],
												[
													242.685,
													58.855
												],
												[
													242.854,
													58.794
												],
												[
													242.908,
													58.775
												],
												[
													243.092,
													58.706
												],
												[
													243.123,
													58.694
												],
												[
													243.327,
													58.615
												],
												[
													243.339,
													58.609
												],
												[
													243.558,
													58.521
												],
												[
													246.161,
													57.229
												],
												[
													246.197,
													57.208
												],
												[
													246.368,
													57.105
												],
												[
													249.389,
													54.855
												],
												[
													249.439,
													54.811
												],
												[
													249.484,
													54.77
												],
												[
													254.127,
													48.458
												],
												[
													255.988,
													40.641
												],
												[
													255.991,
													40.534
												],
												[
													255.992,
													40.466
												],
												[
													255.996,
													40.26
												],
												[
													255.996,
													40.255
												],
												[
													255.997,
													39.939
												],
												[
													255.997,
													-140
												],
												[
													175.997,
													-220
												],
												[
													-176,
													-220
												],
												[
													-256,
													-140
												],
												[
													-256,
													140
												],
												[
													-176,
													220
												],
												[
													13.374,
													220
												],
												[
													13.515,
													220.001
												],
												[
													13.703,
													220
												],
												[
													176,
													220
												],
												[
													256,
													140
												]
											]
										},
										"ix": 2
									}
								},
								{
									"ty": "mm",
									"nm": "Merge Paths 1",
									"mm": 1
								},
								{
									"ty": "fl",
									"nm": "Fill 1",
									"c": {
										"a": 0,
										"k": [
											0.161,
											0.835,
											0.604
										],
										"ix": 4,
										"x": "var $bm_rt;\n$bm_rt = content('image frame').content('sun').content('Fill 1').color;"
									},
									"r": 1,
									"o": {
										"a": 0,
										"k": 100,
										"ix": 5
									}
								},
								{
									"ty": "tr",
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"p": {
										"a": 0,
										"k": [
											256,
											256
										],
										"ix": 2
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									}
								}
							]
						},
						{
							"ty": "tr",
							"a": {
								"a": 0,
								"k": [
									256,
									256.001
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"p": {
								"a": 0,
								"k": [
									256,
									256.001
								],
								"ix": 2
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							}
						}
					]
				}
			],
			"ind": 3
		},
		{
			"ty": 4,
			"nm": "image",
			"sr": 1,
			"st": 0,
			"op": 150,
			"ip": 0,
			"hasMask": false,
			"ao": 0,
			"ks": {
				"a": {
					"a": 0,
					"k": [
						256,
						256,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				},
				"sk": {
					"a": 0,
					"k": 0
				},
				"p": {
					"a": 0,
					"k": [
						600,
						600,
						0
					],
					"ix": 2
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"sa": {
					"a": 0,
					"k": 0
				},
				"o": {
					"a": 1,
					"k": [
						{
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"s": [
								15
							],
							"t": 80
						},
						{
							"s": [
								5
							],
							"t": 90
						}
					],
					"ix": 11
				}
			},
			"ef": [],
			"shapes": [
				{
					"ty": "gr",
					"nm": "image frame",
					"ix": 1,
					"cix": 2,
					"it": [
						{
							"ty": "gr",
							"nm": "sun",
							"ix": 1,
							"cix": 2,
							"it": [
								{
									"ty": "sh",
									"nm": "Path 1",
									"ix": 1,
									"d": 1,
									"ks": {
										"a": 0,
										"k": {
											"c": true,
											"i": [
												[
													-11.028,
													0
												],
												[
													0,
													-11.028
												],
												[
													11.028,
													0
												],
												[
													0,
													11.028
												]
											],
											"o": [
												[
													11.028,
													0
												],
												[
													0,
													11.028
												],
												[
													-11.028,
													0
												],
												[
													0,
													-11.028
												]
											],
											"v": [
												[
													0,
													-20
												],
												[
													20,
													0
												],
												[
													0,
													20
												],
												[
													-20,
													0
												]
											]
										},
										"ix": 2
									}
								},
								{
									"ty": "sh",
									"nm": "Path 2",
									"ix": 2,
									"d": 1,
									"ks": {
										"a": 0,
										"k": {
											"c": true,
											"i": [
												[
													-33.084,
													0
												],
												[
													0,
													33.084
												],
												[
													33.084,
													0
												],
												[
													0,
													-33.084
												]
											],
											"o": [
												[
													33.084,
													0
												],
												[
													0,
													-33.084
												],
												[
													-33.084,
													0
												],
												[
													0,
													33.084
												]
											],
											"v": [
												[
													0,
													60
												],
												[
													60,
													0
												],
												[
													0,
													-60
												],
												[
													-60,
													0
												]
											]
										},
										"ix": 2
									}
								},
								{
									"ty": "mm",
									"nm": "Merge Paths 1",
									"mm": 1
								},
								{
									"ty": "fl",
									"nm": "Fill 1",
									"c": {
										"a": 0,
										"k": [
											0.11,
											0.11,
											0.11
										],
										"ix": 4
									},
									"r": 1,
									"o": {
										"a": 0,
										"k": 100,
										"ix": 5
									}
								},
								{
									"ty": "tr",
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"p": {
										"a": 0,
										"k": [
											140,
											168
										],
										"ix": 2
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									}
								}
							]
						},
						{
							"ty": "gr",
							"nm": "image",
							"ix": 2,
							"cix": 2,
							"it": [
								{
									"ty": "sh",
									"nm": "Path 1",
									"ix": 1,
									"d": 1,
									"ks": {
										"a": 0,
										"k": {
											"c": true,
											"i": [
												[
													0,
													0
												],
												[
													0,
													22.056
												],
												[
													0,
													0
												],
												[
													-22.056,
													0
												],
												[
													0,
													0
												],
												[
													0,
													-22.056
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													6.037,
													-0.091
												],
												[
													3.723,
													-4.736
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													6.202,
													0
												],
												[
													0,
													0
												],
												[
													3.784,
													-4.919
												],
												[
													0,
													0
												],
												[
													-8.755,
													-6.735
												],
												[
													-6.734,
													8.755
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													-22.056,
													0
												],
												[
													0,
													0
												],
												[
													0,
													-22.056
												],
												[
													0,
													0
												],
												[
													22.056,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-3.87,
													-4.618
												],
												[
													-6.024,
													0.094
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-3.786,
													-4.913
												],
												[
													0,
													0
												],
												[
													-6.206,
													0.003
												],
												[
													0,
													0
												],
												[
													-6.734,
													8.755
												],
												[
													8.757,
													6.735
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-176,
													180
												],
												[
													-216,
													140
												],
												[
													-216,
													-140
												],
												[
													-176,
													-180
												],
												[
													176,
													-180
												],
												[
													216,
													-140
												],
												[
													216,
													-14.993
												],
												[
													137.327,
													-108.848
												],
												[
													121.687,
													-115.998
												],
												[
													106.278,
													-108.362
												],
												[
													-47.84,
													87.664
												],
												[
													-100.16,
													19.789
												],
												[
													-116,
													11.999
												],
												[
													-116.01,
													11.999
												],
												[
													-131.853,
													19.805
												],
												[
													-175.868,
													77.023
												],
												[
													-172.21,
													105.07
												],
												[
													-144.163,
													101.413
												],
												[
													-115.984,
													64.78
												],
												[
													-27.168,
													180
												]
											]
										},
										"ix": 2
									}
								},
								{
									"ty": "sh",
									"nm": "Path 2",
									"ix": 2,
									"d": 1,
									"ks": {
										"a": 0,
										"k": {
											"c": true,
											"i": [
												[
													11.046,
													0
												],
												[
													0,
													-11.046
												],
												[
													22.056,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-0.205,
													-0.226
												],
												[
													0,
													0
												],
												[
													-0.025,
													-0.027
												],
												[
													-2.315,
													-1.079
												],
												[
													-2.776,
													-0.092
												],
												[
													-0.051,
													-0.001
												],
												[
													-0.008,
													-0.001
												],
												[
													-1.413,
													0.27
												],
												[
													0,
													0
												],
												[
													-0.064,
													0.013
												],
												[
													-0.026,
													0.005
												],
												[
													-0.054,
													0.012
												],
												[
													-0.03,
													0.007
												],
												[
													-0.049,
													0.011
												],
												[
													-0.034,
													0.009
												],
												[
													-0.043,
													0.01
												],
												[
													-0.038,
													0.009
												],
												[
													-0.041,
													0.01
												],
												[
													-0.038,
													0.01
												],
												[
													-0.042,
													0.011
												],
												[
													-0.038,
													0.01
												],
												[
													0,
													0
												],
												[
													-0.04,
													0.011
												],
												[
													-0.039,
													0.011
												],
												[
													-0.033,
													0.01
												],
												[
													-0.048,
													0.015
												],
												[
													-0.026,
													0.008
												],
												[
													-0.05,
													0.016
												],
												[
													-0.03,
													0.01
												],
												[
													-0.049,
													0.016
												],
												[
													-0.023,
													0.007
												],
												[
													-0.055,
													0.018
												],
												[
													-0.021,
													0.008
												],
												[
													-0.056,
													0.021
												],
												[
													-0.018,
													0.007
												],
												[
													-0.061,
													0.023
												],
												[
													0,
													0
												],
												[
													-0.068,
													0.027
												],
												[
													-0.004,
													0.002
												],
												[
													-0.073,
													0.031
												],
												[
													-0.844,
													0.499
												],
												[
													-0.012,
													0.007
												],
												[
													-0.057,
													0.035
												],
												[
													-0.932,
													0.842
												],
												[
													-0.017,
													0.015
												],
												[
													-0.015,
													0.013
												],
												[
													-1.085,
													2.33
												],
												[
													-0.088,
													2.788
												],
												[
													-0.001,
													0.036
												],
												[
													0,
													0.022
												],
												[
													-0.001,
													0.068
												],
												[
													0,
													0
												],
												[
													0,
													0.106
												],
												[
													0,
													0
												],
												[
													44.112,
													0
												],
												[
													0,
													0
												],
												[
													0,
													-44.113
												],
												[
													0,
													0
												],
												[
													-44.112,
													0
												],
												[
													0,
													0
												],
												[
													-0.047,
													0
												],
												[
													-0.063,
													0.001
												],
												[
													0,
													0
												],
												[
													0,
													44.112
												]
											],
											"o": [
												[
													-11.046,
													0
												],
												[
													0,
													22.056
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0.195,
													0.236
												],
												[
													0,
													0
												],
												[
													0.024,
													0.027
												],
												[
													1.821,
													1.989
												],
												[
													2.378,
													1.112
												],
												[
													0.051,
													0.002
												],
												[
													0.009,
													0
												],
												[
													1.429,
													0.036
												],
												[
													0,
													0
												],
												[
													0.063,
													-0.012
												],
												[
													0.024,
													-0.005
												],
												[
													0.054,
													-0.011
												],
												[
													0.03,
													-0.007
												],
												[
													0.05,
													-0.011
												],
												[
													0.035,
													-0.008
												],
												[
													0.044,
													-0.01
												],
												[
													0.038,
													-0.009
												],
												[
													0.041,
													-0.01
												],
												[
													0.038,
													-0.01
												],
												[
													0.042,
													-0.011
												],
												[
													0.038,
													-0.01
												],
												[
													0,
													0
												],
												[
													0.041,
													-0.012
												],
												[
													0.04,
													-0.011
												],
												[
													0.032,
													-0.009
												],
												[
													0.049,
													-0.015
												],
												[
													0.027,
													-0.008
												],
												[
													0.05,
													-0.015
												],
												[
													0.03,
													-0.01
												],
												[
													0.049,
													-0.016
												],
												[
													0.023,
													-0.008
												],
												[
													0.055,
													-0.019
												],
												[
													0.021,
													-0.007
												],
												[
													0.057,
													-0.019
												],
												[
													0.018,
													-0.007
												],
												[
													0.062,
													-0.023
												],
												[
													0,
													0
												],
												[
													0.068,
													-0.026
												],
												[
													0.004,
													-0.001
												],
												[
													0.073,
													-0.029
												],
												[
													0.889,
													-0.362
												],
												[
													0.012,
													-0.007
												],
												[
													0.057,
													-0.034
												],
												[
													1.078,
													-0.654
												],
												[
													0.017,
													-0.014
												],
												[
													0.015,
													-0.014
												],
												[
													2.005,
													-1.829
												],
												[
													1.115,
													-2.387
												],
												[
													0.001,
													-0.037
												],
												[
													0,
													-0.023
												],
												[
													0.001,
													-0.068
												],
												[
													0,
													0
												],
												[
													0.001,
													-0.105
												],
												[
													0,
													0
												],
												[
													0,
													-44.112
												],
												[
													0,
													0
												],
												[
													-44.112,
													0
												],
												[
													0,
													0
												],
												[
													0,
													44.112
												],
												[
													0,
													0
												],
												[
													0.047,
													0
												],
												[
													0.063,
													0
												],
												[
													0,
													0
												],
												[
													44.112,
													0
												],
												[
													0,
													-11.047
												]
											],
											"v": [
												[
													236,
													120
												],
												[
													216,
													140
												],
												[
													176,
													180
												],
												[
													23.335,
													180
												],
												[
													-22.65,
													120.344
												],
												[
													122.497,
													-64.274
												],
												[
													220.563,
													52.717
												],
												[
													221.163,
													53.411
												],
												[
													221.184,
													53.435
												],
												[
													221.258,
													53.516
												],
												[
													227.534,
													58.125
												],
												[
													235.322,
													59.987
												],
												[
													235.475,
													59.992
												],
												[
													235.501,
													59.992
												],
												[
													239.777,
													59.643
												],
												[
													239.83,
													59.633
												],
												[
													240.018,
													59.596
												],
												[
													240.094,
													59.58
												],
												[
													240.256,
													59.546
												],
												[
													240.346,
													59.526
												],
												[
													240.493,
													59.492
												],
												[
													240.597,
													59.468
												],
												[
													240.729,
													59.437
												],
												[
													240.842,
													59.409
												],
												[
													240.966,
													59.378
												],
												[
													241.079,
													59.348
												],
												[
													241.204,
													59.315
												],
												[
													241.318,
													59.284
												],
												[
													241.436,
													59.252
												],
												[
													241.558,
													59.217
												],
												[
													241.676,
													59.182
												],
												[
													241.773,
													59.154
												],
												[
													241.92,
													59.109
												],
												[
													242,
													59.083
												],
												[
													242.149,
													59.036
												],
												[
													242.239,
													59.007
												],
												[
													242.387,
													58.958
												],
												[
													242.456,
													58.935
												],
												[
													242.622,
													58.878
												],
												[
													242.685,
													58.855
												],
												[
													242.854,
													58.794
												],
												[
													242.908,
													58.775
												],
												[
													243.092,
													58.706
												],
												[
													243.123,
													58.694
												],
												[
													243.327,
													58.615
												],
												[
													243.339,
													58.609
												],
												[
													243.558,
													58.521
												],
												[
													246.161,
													57.229
												],
												[
													246.197,
													57.208
												],
												[
													246.368,
													57.105
												],
												[
													249.389,
													54.855
												],
												[
													249.439,
													54.811
												],
												[
													249.484,
													54.77
												],
												[
													254.127,
													48.458
												],
												[
													255.988,
													40.641
												],
												[
													255.991,
													40.534
												],
												[
													255.992,
													40.466
												],
												[
													255.996,
													40.26
												],
												[
													255.996,
													40.255
												],
												[
													255.997,
													39.939
												],
												[
													255.997,
													-140
												],
												[
													175.997,
													-220
												],
												[
													-176,
													-220
												],
												[
													-256,
													-140
												],
												[
													-256,
													140
												],
												[
													-176,
													220
												],
												[
													13.374,
													220
												],
												[
													13.515,
													220.001
												],
												[
													13.703,
													220
												],
												[
													176,
													220
												],
												[
													256,
													140
												]
											]
										},
										"ix": 2
									}
								},
								{
									"ty": "mm",
									"nm": "Merge Paths 1",
									"mm": 1
								},
								{
									"ty": "fl",
									"nm": "Fill 1",
									"c": {
										"a": 0,
										"k": [
											0.11,
											0.11,
											0.11
										],
										"ix": 4
									},
									"r": 1,
									"o": {
										"a": 0,
										"k": 100,
										"ix": 5
									}
								},
								{
									"ty": "tr",
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"p": {
										"a": 0,
										"k": [
											256,
											256
										],
										"ix": 2
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									}
								}
							]
						},
						{
							"ty": "tr",
							"a": {
								"a": 0,
								"k": [
									256,
									256.001
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"p": {
								"a": 0,
								"k": [
									256,
									256.001
								],
								"ix": 2
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							}
						}
					]
				}
			],
			"ind": 4
		}
	],
	"v": "5.3.4",
	"fr": 60,
	"op": 90,
	"ip": 0,
	"assets": []
};


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lotties/UploadInsuranceCard.json
// module id = 5356
// module chunks = 39